import { AxiosInstance, AxiosRequestConfig, AxiosPromise } from 'axios'
import {
  ItemsResponse,
  MessageRequestParam,
  MessageAction,
} from '/@src/models/api'

export interface AdminCommentUser {
  uid: number
  nickname: string
  avatar?: string
}

export interface AdminCommentItem {
  id: number
  from_user: AdminCommentUser
  to_user: AdminCommentUser
  content?: string
  root_id?: number
  reply_to_id?: number
  thumb_up_count?: number
  created_at: string
  to_item?: {
    id: number
  }
}

export type CommentItemType = 'ARTICLE' | 'VIDEO'

export interface CreateCommentParams {
  at_users?: string[]
  content: string
  find_words?: boolean
  image_url?: string
  item_id?: number
  item_type?: CommentItemType
  reply_to_id: number
}

export interface AdminCommentListParams {
  only_from_me?: boolean
  only_to_me?: boolean
  item_author_id?: number
  comment_type?: number
  status?: number
  anchor?: string
  limit?: number
}

export function getComments(
  api: AxiosInstance,
  limit: number,
  anchor?: string
): Promise<ItemsResponse<Comment>> {
  const data: AxiosRequestConfig = {
    params: {
      limit: limit,
      anchor: anchor,
      action: MessageAction.COMMENT,
    },
  }
  return api.get('/v1/message/actions', data)
}
// 系统消息列表
export function getSystemMessageList(
  api: AxiosInstance,
  params: MessageRequestParam
): AxiosPromise {
  return api.get(`/v1/admin/system-messages?`, {
    params: params,
  })
}

export function getSystemMessageDetail(
  api: AxiosInstance,
  id: string
): AxiosPromise {
  return api.get(`/v1/admin/system-message/${id}`)
}

export function saveSystemMessageList(
  api: AxiosInstance,
  params: MessageRequestParam
): AxiosPromise {
  return api.post(`/v1/admin/system-message`, params)
}

export function getAdminCommentList(
  api: AxiosInstance,
  params: AdminCommentListParams
): Promise<ItemsResponse<AdminCommentItem>> {
  return api.get('/v1/admin/comment/list', {
    params,
  })
}

export function deleteAdminComment(
  api: AxiosInstance,
  cid: number
): AxiosPromise {
  return api.post(`/v1/admin/comment/${cid}/delete`)
}

export function createComment(
  api: AxiosInstance,
  params: CreateCommentParams
): AxiosPromise {
  return api.post('/v1/comment', params)
}
